import trackEventNew, {ActionType as TrackEventNewType} from './trackEventNew'

export type ModuleActionType = TrackEventNewType

export {trackEventNew}
